import type { TFunction } from 'i18next'

/**
 * A recovery-chain tier as the screens name it: Boot, Full, Incremental, Log. Shared by the
 * pre-signed URLs card and the Recovery chain dialog so the same version is named the same way
 * in both. Anything else, or no tier, is a plain "Version".
 */
export function tierLabel(t: TFunction, tier: string | null | undefined): string {
    switch (tier) {
        case 'Boot': return t('recoverRequests.tierBoot', 'Boot')
        case 'Full': return t('recoverRequests.tierFull', 'Full')
        case 'Int': return t('recoverRequests.tierInt', 'Incremental')
        case 'Log': return t('recoverRequests.tierLog', 'Log')
        default: return tier || t('recoverRequests.tierOther', 'Version')
    }
}
